import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { database } from "../../firebase";
import ConnectionAction from "../../redux/connections/actions";
import AsideContacts from "../../components/AsideContacts";
import AsideNewFeed from "../../components/AsideNewFeed";
import Loader from "../../components/Loader"
import './seeall.css'
const SeeAll = () => {
  const [Loading,setLoading]= useState(false)
  document.title = "Requests";
  const dispatch = useDispatch();

  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));

  async function acceptConnection(uid, userId) {
    setLoading(true)
    const updates = {};
    const updates2={};
    updates[`/connectuser/${currentUser.uid}/${uid}/status`] = "Accepted";
    updates2[`/connectuser/${uid}/${currentUser.uid}/status`] = "Accepted";
    await database.ref().update(updates) 
    await database.ref().update(updates2).then(() => {
     return database
    .ref(`/connectuser/${currentUser.uid}`).orderByChild('status').equalTo('Pending')
    .once("value")
    .then(async (snapshot) => {

      const array = [];
      snapshot.forEach((childSnapshot) => {
        array.push(childSnapshot.key);
      });
      var results = await Promise.all(
        array.map(async (item) => {
          const data = await getUserData(item);
          return data;
        })
        );
        setRequests([...results]);
      setLoading(false);
    });
  })
  
    return true;
  }

  async function declineConnection(uid, userId) {
    setLoading(true)
    await database
    .ref(`/connectuser/${currentUser.uid}/${uid}`)
    .remove().then(() => {
      return database
      .ref(`/connectuser/${uid}`).orderByChild('status').equalTo('Pending')
      .once("value")
      .then(async (snapshot) => {
  
        const array = [];
        snapshot.forEach((childSnapshot) => {
          array.push(childSnapshot.key);
        });
        var results = await Promise.all(
          array.map(async (item) => {
            const data = await getUserData(item);
            return data;
          })
          );
          setRequests([...results]);
        setLoading(false);
      });
    });


    

    return true;
  }



  const { connections } = useSelector((state) => ({
    connections: state.connection.connections,

    Loading: state.connection.Loading,
  }));
  const [requests, setRequests] = useState([]);

  function getUserData(uid) {
  return new Promise((resolve, reject) => {
    return database.ref("users/" + uid).once("value", (snap) => {
      resolve(snap.val());
    });
  });
}

function getConnections(uid) {
  setLoading(true)
  return database
    .ref(`/connectuser/${uid}`).orderByChild('status').equalTo('Pending')
    .once("value")
    .then(async (snapshot) => {

      const array = [];
      snapshot.forEach((childSnapshot) => {
        array.push(childSnapshot.key);
      });
      var results = await Promise.all(
        array.map(async (item) => {
          const data = await getUserData(item);
          return data;
        })
      );
      setRequests([...results]);
      setLoading(false)
      return array;
    });
}
  useEffect(() => {
    
    getConnections(currentUser.uid)
  }, []);

  return (
    <>
      <AsideNewFeed></AsideNewFeed>
      <section className="main-content ">
        <div className="middle-box">
          <div className="row">
            <div className="col-sm-12 mb-3">
                  {Loading===true ? <Loader/>:""}

                  {
                       requests.length===0 ? 
                       <div className="pending">
                          <h5 className="text-center">You dont have any Pending Requests</h5> 
                       </div> :
                         <div className="mb-5">
                         <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 g-4">
                        {requests.map((arr) => {
                      return (
                        
                        <div className="col">
                          <div className="rounded-xl shadow-xs p-4 bg-white text-center">
                            <img
                              src={arr?.profileImageUrl}
                              className="mmwh-100 rounded-circle"
                              alt="user"
                            />
                            <h5 className="fw-bold mt-3 text-capitalize">
                              {arr.firstName}
                            </h5>
                            <div className="d-flex flex-wrap justify-content-evenly my-4 text-muted">
                              <div className="px-1">
                                <span className="fs-13">
                                  {" "}
                                  12 Mutual friends
                                </span>
                              </div>
                            </div>
                            <button
                              className="btn btn-primary fw-medium rounded-pill px-3"
                              onClick={() => acceptConnection(arr.uid)}
                            >
                              Accept
                            </button>
                            <button
                              className="btn btn-secondary fw-medium rounded-pill px-3"
                              onClick={() => declineConnection(arr.uid)}
                            >
                              Ignore
                            </button>
                          </div>
                        </div>
                      );
                    }
                    )}
                  
                </div>
              </div>
                  }
            
            
                     
            </div>
          </div>
        </div>
      </section>

      <AsideContacts></AsideContacts>
    </>
  );
};

export default SeeAll;
